import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class StockRow extends Component {
  render() {
      return (
          <tr id={this.props.stock_name}>
              <td>{this.props.stock_name.toUpperCase()}</td>
              <td>
                  {this.props.stock_data}
              </td>                    
          </tr>
      );
  }
};
const StockList = (props) => {
  return(
      <div className='App-intro' id='stocks_list'>
              <table>
                  <thead>
                      <tr>
                      <th>Name</th>
                      <th>Value</th>
                      </tr>
                  </thead>
                  <tbody>
                      {Object.keys(props.stocks).map((name, index) =>
                      {
                          let stock_name = props.stocks[name].name;
                          let price = props.stocks[name].price_usd;
                          return (
                          <StockRow
                              key={index} stock_name={stock_name}
                              stock_data={price}
                          />
                          )
                      }
                      )}
                  </tbody>
              </table>
      </div>
  );
};

class App extends Component {
  state = {
    stocks: []
  }
  componentDidMount = () => {
      this.interval = setInterval(() => this.getStockValues(), 10000);
  }
  componentWillUnmount() {
      clearInterval(this.interval);
  }
  async getStockValues() {
      const response = await fetch(`https://api.coinmarketcap.com/v1/ticker/?limit=10`);
      const json = await response.json();
      this.setState({ stocks: json });
  }
  render() {
      return (
          <div className='App'>
              <div className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <h2>Stocks App</h2>
              </div>
              <StockList stocks={this.state.stocks}/>
          </div>
      ); 
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js